import { Navigate, Outlet, useParams } from 'react-router-dom'

export function InstallationConfigurationRoutes() {
  return <Outlet />
}

export function InstallationConfigurationIndexRedirect() {
  const { installationId } = useParams<{ installationId: string }>()
  if (!installationId) {
    return null
  }
  return (
    <Navigate
      to={`/dashboard/${installationId}/installation/configuration/precursor-cn-codes`}
      replace
    />
  )
}
